import React from 'react'
import RegistrationStepper from "../../../components-user/event-management/lectures/registration/registration-steps/RegistrationStepper"

export default function RegisterTechnicalLecture() {
  return (
    <RegistrationStepper />
  )
}
